import columnTypes from '../columnTypes.js';
import types from '../types.js';

const ActiveDirectoryTables = [
  {
    key: 'ad-granular-details',
    name: 'AD Granular Details',
    [columnTypes.default.key]: [
      {
        source: 'SamAccountName',
        rename: 'Group Name',
        type: types.text,
      },
      {
        source: 'ShortName',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'OwnerName',
        rename: 'Owner',
        type: types.text,
      },
      {
        source: 'ManagedBy',
        rename: 'Managed By',
        type: types.text,
      },
      {
        source: 'TotalChildren',
        rename: 'Children',
        type: types.number,
      },
      {
        source: 'TotalUsers',
        rename: 'Users',
        type: types.number,
      },
      {
        source: 'UniqueUsers',
        rename: 'Unique Users',
        type: types.number,
      },
      {
        source: 'NumSubGroups',
        rename: 'SubGroups',
        type: types.number,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Division',
        type: types.text,
      },
      {
        source: 'GroupScope',
        rename: 'Scope',
        type: types.text,
      },
      {
        source: 'GroupType',
        rename: 'Type',
        type: types.text,
      },
      {
        source: 'CreateDate',
        rename: 'Created',
        type: types.date,
      },
      {
        source: 'ModifyDate',
        rename: 'Modified',
        type: types.date,
      },
      {
        source: 'SVA',
        rename: 'Group Status',
        type: types.text,
      },
      {
        source: 'CircularReference',
        rename: 'Circular',
        type: types.text,
      },
      {
        source: 'Source',
        rename: 'Source',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'AdminUsers',
        rename: 'Admin Users',
        type: types.number,
      },
      {
        source: 'ObjectSid',
        rename: 'ObjectSid',
        type: types.text,
      },
      {
        source: 'DisplayName',
        rename: 'DisplayName',
        type: types.text,
      },
      {
        source: 'Cn',
        rename: 'Cn',
        type: types.text,
      },
      {
        source: 'SAMAccountType',
        rename: 'SAMAccountType',
        type: types.text,
      },
      {
        source: 'Info',
        rename: 'Info',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute1',
        rename: 'ExtensionAttribute1',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute2',
        rename: 'ExtensionAttribute2',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute3',
        rename: 'ExtensionAttribute3',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute4',
        rename: 'ExtensionAttribute4',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute5',
        rename: 'ExtensionAttribute5',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute6',
        rename: 'ExtensionAttribute6',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute7',
        rename: 'ExtensionAttribute7',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute8',
        rename: 'ExtensionAttribute8',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute9',
        rename: 'ExtensionAttribute9',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute10',
        rename: 'ExtensionAttribute10',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute11',
        rename: 'ExtensionAttribute11',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute12',
        rename: 'ExtensionAttribute12',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute13',
        rename: 'ExtensionAttribute13',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute14',
        rename: 'ExtensionAttribute14',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute15',
        rename: 'ExtensionAttribute15',
        type: types.text,
      },
      {
        source: 'DLMemRejectPerms',
        rename: 'DLMemRejectPerms',
        type: types.text,
      },
      {
        source: 'DLMemSubmitPerms',
        rename: 'DLMemSubmitPerms',
        type: types.text,
      },
      {
        source: 'AuthOrig',
        rename: 'AuthOrig',
        type: types.text,
      },
      {
        source: 'UnauthOrig',
        rename: 'UnauthOrig',
        type: types.text,
      },
      {
        source: 'Mail',
        rename: 'Mail',
        type: types.text,
      },
      {
        source: 'MailNickname',
        rename: 'MailNickname',
        type: types.text,
      },
      {
        source: 'MsExchHideFromAddressLists',
        rename: 'MsExchHideFromAddressLists',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'GroupDepth',
        rename: 'Depth',
        type: types.number,
      },
      {
        source: 'Description',
        rename: 'Description',
        type: types.text,
      },
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
      {
        source: 'IsAdmin',
        rename: 'Is Admin',
        type: types.text,
      },
      {
        source: 'IsEmpty',
        rename: 'Is Empty',
        type: types.text,
      },
      {
        source: 'RegularUsers',
        rename: 'Regular Users',
        type: types.number,
      },
      {
        source: 'SystemAccounts',
        rename: 'System Accounts',
        type: types.number,
      },
      {
        source: 'Name',
        rename: 'Name',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      { source: 'BUID', rename: 'BUID' },
      { source: 'CMID', rename: 'CMID' },
      { source: 'UniqueID', rename: 'UniqueID' },
      { source: 'STSGuid', rename: 'STSGuid' },
      { source: 'domainID', rename: 'domainID' },
      { source: 'OwnerID', rename: 'OwnerID' },
    ],
  },
];

export default [...ActiveDirectoryTables];
